import FloatingToolbar from './FloatingToolbar'

export default FloatingToolbar